import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/service/navigation.service';

@Component({
    selector: 'departments',
    templateUrl: './departments.component.html',
    styleUrls: ['./departments.component.scss']
})
export class DepartmentsComponent implements OnInit {
    constructor(private navigationService: NavigationService) { }

    ngOnInit(): void {
        this.navigationService.activity.setupQuickly('Консульские учреждения');
    }
}
